





































































































































































































import { defineComponent, ref, useContext } from '@nuxtjs/composition-api';
import {
  SfButton,
  SfFooter,
  SfImage,
  SfLink,
  SfList,
  SfMenuItem,
} from '@storefront-ui/vue';

import HeaderLogo from '~/components/HeaderLogo.vue';
import { useMagentoConfiguration } from '~/composables/useMagentoConfiguration';
import { addBasePath } from '~/helpers/addBasePath';

import SocialList from './SocialList.vue';

export default defineComponent({
  components: {
    SfFooter,
    SfList,
    SfImage,
    SfMenuItem,
    HeaderLogo,
    SfLink,
    SfButton,
    SocialList,
  },
  setup() {
    const isOpen = ref(false);
    const { selectedLocale } = useMagentoConfiguration();

    const {
      $config: { currentSite },
    } = useContext();

    const site = [
      {
        id: 1,
        siteValue: 'gb',
        siteName: 'unineed international site',
        icon: 'gb',
        link: 'https://www.unineed.com/',
      },
      {
        id: 2,
        siteValue: 'cn',
        siteName: 'unineed 中文网站',
        icon: 'cn',
        link: 'https://cn.unineed.com/',
      },
      {
        id: 3,
        siteValue: 'us',
        siteName: 'unineed us',
        icon: 'us',
        link: 'https://us.unineed.com/',
      },
      {
        id: 4,
        siteValue: 'mex',
        siteName: 'unineed mexico',
        icon: 'mex',
        link: 'https://mx.unineed.com/',
      },
      // {
      //   id: 5,
      //   siteValue: 'aurawest',
      //   siteName: 'aurawest',
      //   icon: 'aurawest',
      //   link: 'https://aurawest.com/',
      // },
    ];
    const selectedLocaleIndex = site.findIndex(
      (item) => item.siteValue === selectedLocale.value
    );
    const customerCare = [
      {
        label: 'Customer Services',
        link:
          // eslint-disable-next-line no-nested-ternary
          currentSite === 'cn'
            ? 'https://unineed.zendesk.com/hc/cn-gb'
            : currentSite === 'mex'
            ? 'https://unineed.zendesk.com/hc/es-mx'
            : 'https://unineed.zendesk.com/hc/en-gb',
        islocal: 0,
      },
      {
        label: 'Delivery & Shipping',
        link:
          currentSite === 'cn'
            ? 'https://unineed.zendesk.com/hc/cn-gb/categories/360003491377-Delivery-Tracking'
            : 'https://unineed.zendesk.com/hc/en-gb/categories/360003491377-Delivery-Tracking',
        islocal: 0,
      },
      {
        label: 'Track Your Parcel',
        link:
          currentSite === 'mex' ? '/mx-track-order-info' : '/track-order-info',
        islocal: 1,
      },
      {
        label: 'Return & Refund Policy',
        link:
          currentSite === 'cn'
            ? 'https://unineed.zendesk.com/hc/cn-gb/categories/360003492878-Returns-Refunds'
            : 'https://unineed.zendesk.com/hc/en-gb/categories/360003492878-Returns-Refunds',
        islocal: 0,
      },
      {
        label: 'My Account',
        link: '/user/signin',
        islocal: 1,
      },
    ];

    const aboutUs = [
      {
        label: 'About Us',
        link: currentSite === 'mex' ? '/mx-about' : '/about',
        islocal: 1,
      },
      {
        label: 'Affiliate Signup',
        link: '/user/signin',
        islocal: 1,
      },
    ];
    const legal = [
      {
        label: 'Terms & Conditions',
        link:
          currentSite === 'mex'
            ? '/mx-terms-and-conditions'
            : '/terms-and-conditions',
        islocal: 1,
      },
      {
        label: 'Privacy Statement',
        link:
          currentSite === 'mex'
            ? '/mx-privacy-statement'
            : '/privacy-statement',
        islocal: 1,
      },
      {
        label: 'Cookies',
        link: currentSite === 'mex' ? '/mx-enable-cookies' : '/enable-cookies',
        islocal: 1,
      },
      {
        label: 'DMCA',
        link: currentSite === 'mex' ? '/mx-dmca' : '/dmca',
        islocal: 1,
      },
    ];

    return {
      isOpen,
      addBasePath,
      selectedLocale,
      selectedLocaleIndex,
      customerCare,
      aboutUs,
      legal,
      site,
      currentSite,
    };
  },
  data() {
    return {
      isMobile: false,
      desktopMin: 1024,
    };
  },
});
